/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ServiceAccountCredentialsBaseForAzureApiKey extends models.ServiceAccountCredentialsBaseForAzure {
    constructor() {
        super();
        this.setDiscriminator("ServiceAccountCredentialsBaseForAzureApiKey");
    }

    getFixupPrototypeFunction() { return ServiceAccountCredentialsBaseForAzureApiKey.fixupPrototype; }

    static newInstance(model: Partial<ServiceAccountCredentialsBaseForAzureApiKey>): ServiceAccountCredentialsBaseForAzureApiKey {
        let obj = Object.assign(new ServiceAccountCredentialsBaseForAzureApiKey(), model);
        ServiceAccountCredentialsBaseForAzureApiKey.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ServiceAccountCredentialsBaseForAzureApiKey>): ServiceAccountCredentialsBaseForAzureApiKey {
        if (!model) return null;
        return ServiceAccountCredentialsBaseForAzureApiKey.newInstance(<ServiceAccountCredentialsBaseForAzureApiKey> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ServiceAccountCredentialsBaseForAzureApiKey) {
        if (!obj) return;

        models.ServiceAccountCredentialsBaseForAzureApiKey.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ServiceAccountCredentialsBaseForAzureApiKey): boolean {
        if (models.ServiceAccountCredentialsBaseForAzure.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, ServiceAccountCredentialsBaseForAzureApiKey.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    /**
     * API Key. This is a required field.
     */
    api_key: string;

}
